// Autogenerated from `packages/@members/copy/copy.generated/__copy__.ts.hbs`

import { toCopyComponent } from '@core/copy-generic/models';
import type { CopyHook } from '@core/copy-generic/models';
import toFormattedText from '@core/copy/toFormattedText';
import type { CopyIDs } from '../CopyIDs';
import { useAllCopy } from '../CopyProvider/CopyProvider';
import type { Schedule } from '../models.generated/Schedule';

export const useSchedule: CopyHook<CopyIDs<typeof Schedule>> = (id, values) => {
  const copy = useAllCopy();
  const value = copy?.scheduleCollection?.[id];

  if (!value) {
    console.error(`No copy found for id ${id}`);
    return '';
  }

  return toFormattedText(value, values) as string;
};

export const ScheduleCopy = toCopyComponent(useSchedule);
